export const SERVER_URL = "https://do-calculate.com/api";

export const chemistryCalculators_Fr = [
  {
    name: "Calculatrice de densité",
    link: "/calculator/fr/density-calculator/",
    description:
      "La calculatrice de densité calcule la densité d'une substance en fonction de sa masse et de son volume.",
    showMain: true,
  },
  {
    name: "Calculatrice du point de rosée",
    link: "/calculator/fr/dew-point-calculator/",
    description:
      "La calculatrice du point de rosée estime la température du point de rosée.",
    showMain: true,
  },
  {
    name: "Calculatrice de dilution",
    link: "/calculator/fr/dilution-calculator/",
    description:
      "La calculatrice de dilution calcule la concentration finale d'une solution diluée.",
    showMain: true,
  },
  {
    name: "Calculatrice du volume de gaz",
    link: "/calculator/fr/gas-volume-calculator/",
    description:
      "La calculatrice du volume de gaz calcule le volume d'un gaz en fonction de ses conditions.",
    showMain: true,
  },
  {
    name: "Calculatrice d'énergie libre de Gibbs",
    link: "/calculator/fr/gibbs-free-energy/",
    description:
      "La calculatrice d'énergie libre de Gibbs calcule l'énergie libre de Gibbs d'une réaction chimique.",
    showMain: true,
  },
  {
    name: "Loi des gaz parfaits",
    link: "/calculator/fr/ideal-gas-law-calculator/",
    description:
      "La calculatrice de la loi des gaz parfaits résout pour l'une des quatre variables de la loi des gaz parfaits.",
    showMain: true,
  },
  {
    name: "Calculatrice de charge ionique",
    link: "/calculator/fr/ion-charge-calculator/",
    description:
      "La calculatrice de charge ionique calcule la charge d'un ion chimique.",
    showMain: true,
  },
  {
    name: "Calculatrice de masse de fer",
    link: "/calculator/fr/iron-mass/",
    description:
      "La calculatrice de masse de fer calcule la masse du fer dans un composé.",
    showMain: true,
  },
  {
    name: "Calculatrice Ksp",
    link: "/calculator/fr/ksp-calculator/",
    description:
      "La calculatrice Ksp calcule le produit de solubilité (Ksp) d'une substance.",
    showMain: true,
  },
  {
    name: "Calculatrice de molarité",
    link: "/calculator/fr/molarity-calculator/",
    description:
      "La calculatrice de molarité calcule la molarité d'une solution chimique.",
    showMain: true,
  },
  {
    name: "Calculatrice de masse molaire",
    link: "/calculator/fr/molar-mass-calculator/",
    description:
      "La calculatrice de masse molaire calcule la masse molaire d'une molécule chimique.",
    showMain: true,
  },
  {
    name: "Calculatrice du poids moléculaire",
    link: "/calculator/fr/molecular-weight-calculator/",
    description:
      "La calculatrice du poids moléculaire calcule le poids moléculaire d'une molécule.",
    showMain: true,
  },
  {
    name: "Calculatrice de moles",
    link: "/calculator/fr/moles-calculator/",
    description:
      "La calculatrice de moles convertit la masse en moles et vice versa.",
    showMain: true,
  },
  {
    name: "Calculatrice de poids métallique",
    link: "/calculator/fr/metal-weight/",
    description:
      "La calculatrice de poids métallique calcule le poids d'un métal.",
    showMain: true,
  },
  {
    name: "Calculatrice du pH",
    link: "/calculator/fr/ph-calculator/",
    description:
      "La calculatrice du pH calcule le pH d'une solution chimique.",
    showMain: true,
  },
  {
    name: "Calculatrice de solubilité",
    link: "/calculator/fr/solubility-calculator/",
    description:
      "La calculatrice de solubilité calcule la solubilité d'une substance.",
    showMain: true,
  },
  {
    name: "Titration",
    link: "/calculator/fr/titration/",
    description:
      "La calculatrice de titration calcule la quantité de titrant nécessaire pour une titration.",
    showMain: true,
  },
  {
    name: "Calculatrice de masse d'eau",
    link: "/calculator/fr/water-mass/",
    description:
      "La calculatrice de masse d'eau calcule la masse d'eau dans une solution.",
    showMain: true,
  },
];
